import React from "react";

export default function UserInteractions() {
  return <div>UserInteractions</div>;
}
